import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../api-config";

export default function AccountsList() {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const toggleSelection = (e, id) => {
    e.stopPropagation();
    setSelectedAccounts(prev => 
      prev.includes(id) ? prev.filter(aid => aid !== id) : [...prev, id]
    );
  };

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await axios.get(`${API_URL}/trading-api/reports/accounts/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        setAccounts(response.data);
      } catch (error) {
        console.error("Error fetching accounts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAccounts();
  }, []);

  if (loading) {
    return (
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, idx) => (
          <div key={idx} className="h-32 w-full bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="mt-16 space-y-6">
      {/* Botones de acción superior */}
      <div className="flex justify-end gap-4">
        {selectedAccounts.length > 0 && (
          <button
            onClick={() => navigate(`/report/${selectedAccounts.join(",")}`)}
            className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded shadow transition"
          >
            Ver Seleccionados ({selectedAccounts.length})
          </button>
        )}
        <button
          onClick={() => navigate("/upload-report")}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded shadow transition"
        >
          Subir nuevo reporte
        </button>
      </div>

      {/* Lista de cuentas */}
      <div className="grid gap-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {accounts.map((account) => (
          <div
            key={account.id}
            onClick={() => navigate(`/report/${account.id}`)}
            className={`relative p-4 rounded-lg shadow-md hover:shadow-xl transition cursor-pointer border-2 flex flex-col ${
              selectedAccounts.includes(account.id)
                ? "border-green-500 bg-green-50 dark:bg-gray-700 dark:border-green-400"
                : "border-transparent bg-white dark:bg-gray-800"
            }`}
          >
            <div className="absolute top-4 right-4">
              <input
                type="checkbox"
                checked={selectedAccounts.includes(account.id)}
                onChange={(e) => toggleSelection(e, account.id)}
                onClick={(e) => e.stopPropagation()}
                className="w-5 h-5 text-green-600 bg-gray-100 border-gray-300 rounded focus:ring-green-500 cursor-pointer"
              />
            </div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white pr-8">{account.account_name}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-300">{account.broker_name}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400">Login: {account.login}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
